/* eslint-disable no-unused-vars */
import { Card, CardContent, Grid, Typography } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { PricingUtils } from "../../../utils/PricingUtils";
import { PrintUtils } from "../../../utils/PrintUtils";
import { SaleUtils } from "../../../utils/SaleUtils";
import db from "../../../db/db";
import { use } from "i18next";

export const DayCloseSummary = (props) => {
  const { t } = useTranslation();
  const translate = t;
  props.biRef.dayCloseSummaryWindow = {
    parentEvent: parentEvent,
  };
  //export default function SaleWindow(props) {
  const [payOutList, setPayOutList] = useState(null);
  const [payinList, setPayinList] = useState(null);

  const [openWindow, setOpenWindow] = useState(true);

  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");

  const [cashSummary, setCashSummary] = useState({ openTotal: null });
  const [saleSummary, setSaleSummary] = useState({
    sales: [],
    tax: null,
    total: null,
  });
  const [saleSummaryTotal, setSaleSummaryTotal] = useState("");
  const [isLoaderEnabled, setIsLoaderEnabled] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [fxFlag, setFxFlag] = useState(false);

  function onCloseWindow() {
    props.setShowDayCloseSummary(false);
  }

  useEffect(() => {
    initScreen();
  }, []);

  function parentEvent(event, value) {
    console.log(event + value);
    if ("openWindow" === event) {
      setOpenWindow(value);
      initScreen();
      setAmount("");
      console.log(event + value);
    }
  }
  async function initScreen() {
    try {
      setIsLoaderEnabled(true);
      let { data } = await API.get(
        "/api/v1/salesession/getSession/" + props.saleSession.id
      );
      if (props.shiftMode) {
        let shift = SaleUtils.getShiftSaleSession(data);

        setFxFlag(false);
        Object.entries(shift.saleSummaryV2.SALE).map(([item, value]) => {
          if (value.isFx) {
            setFxFlag(true);
          }
        });

        setSaleSummary(shift.saleCloseSummary);
        setCashSummary(shift.cashCloseSummary);
      } else {
        setFxFlag(false);
        Object.entries(data.saleSummaryV2.SALE).map(([item, value]) => {
          if (value.isFx) {
            setFxFlag(true);
          }
        });

        if (data.saleSummaryV2.PAY_CODES.payin) {
          let payInData = { list: [] };
          Object.entries(data.saleSummaryV2.PAY_CODES.payin.details).map(
            ([item, value]) => {
              console.log(value);
              payInData.list.push(value);
            }
          );
          payInData["totalAmount"] = data.saleSummaryV2.PAY_CODES.payin.amount;
          setPayinList(payInData);
        }

        if (data.saleSummaryV2.PAY_CODES.payout) {
          let payOutData = { list: [] };
          Object.entries(data.saleSummaryV2.PAY_CODES.payout.details).map(
            ([item, value]) => {
              console.log(value);
              payOutData.list.push(value);
            }
          );
          payOutData["totalAmount"] =
            data.saleSummaryV2.PAY_CODES.payout.amount;
          setPayOutList(payOutData);
        }

        setSaleSummary(data.saleCloseSummary);

        setCashSummary(data.cashCloseSummary);
      }
      setIsLoaderEnabled(false);
      //setSaleSummaryTotal(calculateSaleSummaryTotal(data.saleSummary));
    } catch (err) {
      setIsLoaderEnabled(false);
      console.error(err);
    }
  }

  async function onSave() {
    setSaveInProgress(true);
    let json = localStorage.getItem("terminal");

    let j = JSON.parse(json);
    let amt = "0.00";
    if (parseFloat(amount) > 0) {
      amt = amount;
    }
    PricingUtils.formattedNumber(amt, props.context.store.currencyDecimal);
    try {
      let { data } = await API.post("/api/v1/salesession/close_sale", {
        saleSessionId: props.saleSession ? props.saleSession.id : null,
        shiftMode: props.shiftMode,
      });
      let dataToPrint = {};

      if (props.shiftMode) {
        dataToPrint = SaleUtils.getShiftSaleSession(data);
      } else {
        dataToPrint = data;
      }
      await props.checkSaleFlow();

      await db.table("sale").clear();
      await db.table("sale_return").clear();
      await db.table("sale_order").clear();
      await db.table("sale_hold").clear();
      await db.table("sale_hold").clear();
      await db.table("sale_return_hold").clear();

      try {
        await PrintUtils.printReceipt(
          props.terminalBean,
          getFormat(),
          dataToPrint,
          props.setAlert,
          true,
          translate,
          false,
          false,
          null,
          props.pdfViewer
        );
      } catch (err) {
        console.log(err);
      }

      setSaveInProgress(false);

      props.setShowDayCloseSummary(false);
    } catch (err) {
      setSaveInProgress(false);
      console.log(err);
      props.showMessage("error", err.response.data);
    }
  }

  function getFormat() {
    if (props.shiftMode) return "SHIFT_CLOSE_PRINT_FORMAT";
    if (props.context.storeAdmin.enableShift)
      return "DAY_CLOSE_SHIFT_SUMMARY_PRINT_FORMAT";
    else return "DAY_CLOSE_PRINT_FORMAT";
  }

  function onDelete() {}
  const content = (
    <Grid container>
      {(props.shiftMode || !props.context.storeAdmin.enableShift) && (
        <Grid item sm={6} sx={{ padding: "2px" }}>
          <Card style={{ marginTop: 5 }} variant="outlined">
            <CardContent>
              <b>{translate("Cash Summary")}</b>
              <table width={"100%"}>
                <tbody>
                  <tr>
                    <td
                      align="left"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Currency")}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Amount")}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Ex Rate")}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Net Amount")}
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="left"
                      style={{
                        fontStyle: "italic",
                        textDecoration: "underline",
                      }}
                    >
                      {translate("Cash Opening")}
                    </td>
                  </tr>
                  {cashSummary.open &&
                    cashSummary.open.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.srcAmount}</td>
                        <td align="right">{item.exRate}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {translate("Total")}
                    </td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {cashSummary.openTotal && cashSummary.openTotal.amount}
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="left"
                      style={{
                        fontStyle: "italic",
                        textDecoration: "underline",
                      }}
                    >
                      {translate("Transactions")}
                    </td>
                  </tr>
                  {cashSummary.transaction &&
                    cashSummary.transaction.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.srcAmount}</td>
                        <td align="right">{item.exRate}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {translate("Total")}
                    </td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {cashSummary.transactionTotal &&
                        cashSummary.transactionTotal.amount}
                    </td>
                  </tr>
                  <tr>
                    <td
                      align="left"
                      style={{
                        fontStyle: "italic",
                        textDecoration: "underline",
                      }}
                    >
                      {translate("Cash in Hand")}
                    </td>
                  </tr>
                  {cashSummary.close &&
                    cashSummary.close.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.srcAmount}</td>
                        <td align="right">{item.exRate}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {translate("Total")}
                    </td>
                    <td align="right" style={{ fontWeight: "bold" }}>
                      {cashSummary.closeTotal && cashSummary.closeTotal.amount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardContent>
          </Card>
          {(payinList != null || payOutList != null) && (
            <Card style={{ marginTop: 5 }} variant="outlined">
              <CardContent>
                <b>{translate("Sale Summary")}</b>
                <table width={"100%"}>
                  <tbody>
                    <tr>
                      <td
                        align="left"
                        style={{
                          borderTop: "1px solid grey",
                          borderBottom: "1px solid grey",
                        }}
                      >
                        {translate("Pay Code")}
                      </td>
                      <td
                        align="right"
                        style={{
                          borderTop: "1px solid grey",
                          borderBottom: "1px solid grey",
                        }}
                      >
                        {translate("Net Sales")}
                      </td>
                    </tr>
                    {saleSummary.sales &&
                      saleSummary.sales.map((item) => (
                        <tr>
                          <td>{item.code}</td>
                          <td align="right">{item.amount}</td>
                        </tr>
                      ))}
                    {saleSummary.tax && (
                      <tr>
                        <td
                          style={{
                            borderTop: "1px solid grey",
                          }}
                        >
                          TAX
                        </td>
                        <td
                          align="right"
                          style={{
                            borderTop: "1px solid grey",
                          }}
                        >
                          {saleSummary.tax.amount}
                        </td>
                      </tr>
                    )}{" "}
                    {saleSummary.total && (
                      <tr>
                        <td
                          style={{
                            borderBottom: "1px solid grey",
                          }}
                        >
                          Total
                        </td>
                        <td
                          align="right"
                          style={{
                            borderBottom: "1px solid grey",
                          }}
                        >
                          {saleSummary.total.amount}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardContent>
            </Card>
          )}
        </Grid>
      )}
      <Grid
        item
        sm={!props.shiftMode && props.context.storeAdmin.enableShift ? 12 : 6}
        style={{ width: "100%", padding: "2px" }}
      >
        {payinList && payinList.list.length > 0 && (
          <Card style={{ marginTop: 5 }} variant="outlined">
            <CardContent>
              <b>{translate("Pay In")}</b>
              <table width={"100%"}>
                <tbody>
                  <tr>
                    <td
                      align="left"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Pay Code")}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Amount")}
                    </td>
                  </tr>
                  {payinList &&
                    payinList.list.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}

                  {payinList && payinList.totalAmount && (
                    <tr>
                      <td
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        Total
                      </td>
                      <td
                        align="right"
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        {payinList.totalAmount}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardContent>
          </Card>
        )}

        {payOutList && payOutList.list.length > 0 && (
          <Card style={{ marginTop: 5 }} variant="outlined">
            <CardContent>
              <b>{translate("Pay Out")}</b>
              <table width={"100%"}>
                <tbody>
                  <tr>
                    <td
                      align="left"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Pay Code")}
                    </td>

                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Amount")}
                    </td>
                  </tr>

                  {payOutList &&
                    payOutList.list.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}

                  {payOutList && payOutList.totalAmount && (
                    <tr>
                      <td
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        Total
                      </td>
                      <td
                        align="right"
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        {payOutList.totalAmount}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardContent>
          </Card>
        )}

        {payinList == null && payOutList == null && (
          <Card style={{ marginTop: 5 }} variant="outlined">
            <CardContent>
              <b>{translate("Sale Summary")}</b>
              <table width={"100%"}>
                <tbody>
                  <tr>
                    <td
                      align="left"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Pay Code")}
                    </td>
                    <td
                      align="right"
                      style={{
                        borderTop: "1px solid grey",
                        borderBottom: "1px solid grey",
                      }}
                    >
                      {translate("Net Sales")}
                    </td>
                  </tr>
                  {saleSummary.sales &&
                    saleSummary.sales.map((item) => (
                      <tr>
                        <td>{item.code}</td>
                        <td align="right">{item.amount}</td>
                      </tr>
                    ))}
                  {saleSummary.tax && (
                    <tr>
                      <td
                        style={{
                          borderTop: "1px solid grey",
                        }}
                      >
                        TAX
                      </td>
                      <td
                        align="right"
                        style={{
                          borderTop: "1px solid grey",
                        }}
                      >
                        {saleSummary.tax.amount}
                      </td>
                    </tr>
                  )}{" "}
                  {saleSummary.total && (
                    <tr>
                      <td
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        Total
                      </td>
                      <td
                        align="right"
                        style={{
                          borderBottom: "1px solid grey",
                        }}
                      >
                        {saleSummary.total.amount}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardContent>
          </Card>
        )}

        <Card style={{ marginTop: 5 }} variant="outlined">
          <CardContent>
            <b>{translate("Variance")}</b>
            <table width={"100%"}>
              <tbody>
                <tr>
                  <td
                    align="left"
                    style={{
                      borderTop: "1px solid grey",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {translate("Currency")}
                  </td>
                  <td
                    align="right"
                    style={{
                      borderTop: "1px solid grey",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {translate("Open")}
                  </td>
                  <td
                    align="right"
                    style={{
                      borderTop: "1px solid grey",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {translate("Transaction")}
                  </td>
                  <td
                    align="right"
                    style={{
                      borderTop: "1px solid grey",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {translate("Close")}
                  </td>
                  <td
                    align="right"
                    style={{
                      borderTop: "1px solid grey",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {translate("Variance")}
                  </td>
                </tr>
                {cashSummary.summary &&
                  cashSummary.summary.map((item) => (
                    <tr>
                      <td>{item.code}</td>
                      <td align="right">{item.open}</td>
                      <td align="right">{item.transaction}</td>
                      <td align="right">{item.close}</td>
                      <td align="right">{item.variance}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={
            props.shiftMode
              ? translate("Shift Close Summary")
              : translate("Day Close Summary")
          }
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          isLoaderEnabled={isLoaderEnabled}
          saveLabel={
            props.shiftMode ? translate("Close Shift") : translate("Close Day")
          }
          mode={"create"}
          disableClose={true}
          saveDisabled={saveInProgress}
          isSaveLoaderEnabled={saveInProgress}
        ></PDialog>
      )}
    </div>
  );
};
export default DayCloseSummary;
